import { EntityTable } from '@/features/admin/EntityTable';

export function FornecedoresPage() {
  return (
    <EntityTable
      title="Fornecedores"
      subtitle="Fabricantes de instrumental, insumos e prestadores de manutenção"
      endpoint="/v1/suppliers"
      queryKey="suppliers"
      columns={[
        { key: 'name', label: 'Nome' },
        { key: 'cnpj', label: 'CNPJ', className: 'font-mono text-xs' },
        { key: 'supply_kinds', label: 'Tipos de fornecimento', className: 'text-xs text-neutral-500' },
        { key: 'contact_email', label: 'Contato', className: 'text-xs text-neutral-500' },
      ]}
      fields={[
        { name: 'name', label: 'Razão social', type: 'text', required: true },
        { name: 'cnpj', label: 'CNPJ', type: 'text', placeholder: '00.000.000/0000-00' },
        { name: 'supply_kinds', label: 'Tipos (CSV)', type: 'text', hint: 'ex.: INSTRUMENT,CONSUMABLE,MAINTENANCE', required: true },
        { name: 'contact_email', label: 'E-mail', type: 'email' },
        { name: 'contact_phone', label: 'Telefone', type: 'text' },
      ]}
    />
  );
}
